import { type Component, createEffect } from 'solid-js'
import { createStore } from 'solid-js/store'
import Button from '~/components/Button'
import Form from '~/components/Form'
import Input from '~/components/Input'
import Modal from '~/components/Modal'
import Textarea from '~/components/Textarea'

export interface StepModalPropsType {
  isOpen: boolean
  onClose: () => void
  step: { title: string; description: string } | null
  onSave: (step: { title: string; description: string }) => void
}

/** Alta y edición de un paso de "Cómo trabajamos". Mismo patrón que `FichaModal`. */
const StepModal: Component<StepModalPropsType> = props => {
  const [draft, setDraft] = createStore<{ title: string; description: string }>({ title: '', description: '' })

  createEffect(() => {
    if (!props.isOpen) return
    const step = props.step
    setDraft(step ? { title: step.title, description: step.description } : { title: '', description: '' })
  })

  const isValid = () => draft.title.trim().length > 0

  const handleSave = () => {
    if (!isValid()) return
    props.onSave({ title: draft.title.trim(), description: draft.description.trim() })
  }

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="sm" closable>
      <Modal.Header>
        <h2 class="text-lg font-bold text-foreground">{props.step ? 'Editar paso' : 'Nuevo paso'}</h2>
      </Modal.Header>
      <Modal.Body>
        <Form id="step-form" onSubmit={handleSave}>
          <div class="space-y-4">
            <Input label="Título" value={draft.title} onInput={e => setDraft('title', e.currentTarget.value)} placeholder="Descubrimiento" required />
            <Textarea
              label="Descripción"
              value={draft.description}
              onInput={e => setDraft('description', e.currentTarget.value)}
              rows={3}
              placeholder="Entendemos tu operación y definimos objetivos"
            />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div class="flex justify-end gap-2">
          <Button variant="soft" color="default" onClick={props.onClose}>
            Cancelar
          </Button>
          <Button type="submit" form="step-form" disabled={!isValid()}>
            {props.step ? 'Guardar' : 'Añadir'}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default StepModal
